import axios from 'axios';
import {KRBS_TONS} from '../../config/constanst.config';
import {AlertService} from '../../service/alert.service';
import {AppService} from '../../service/app.service';
import {commit} from 'lodash/seq';

const initCrewTonRemarksState = () => {
  return {
    crewTonRemark: {},
    crewTonRemarks: [],
    newCrewTonRemark: {},
  };
};

/** state **/
const state = {
  ...initCrewTonRemarksState(),
};

/** mutations **/
const mutations = {
  set_crew_ton_remark(state, payload) {
    state.crewTonRemark = payload;
  },

  set_crew_ton_remarks(state, payload) {
    state.crewTonRemarks = payload;
  },

  create_ton_remark(state, payload) {
    state.crewTonRemarks.unshift(payload);
    state.newCrewTonRemark = {};
  },

  update_ton_remark(state, payload) {
    let remark = state.crewTonRemarks.find((v, k) => v.remarkId === payload.remarkId);
    Object.assign(remark, payload);
  },

  delete_ton_remark(state, payload) {
    let remark = state.crewTonRemarks.findIndex((v, k) => v.remarkId === payload.remarkId);
    state.crewTonRemarks.splice(remark, 1);
  },

  reset_crew_ton_remark(state) {
    state.crewTonRemark = {};
  },

  reset_crew_to_remarks(state) {
    state.crewTonRemarks = [];
  },

  reset_crew_ton_remarks_state(state) {
    Object.assign(state, initCrewTonRemarksState());
  },
};

/** actions **/
const actions = {

  /** from tons **/
  setCrewTonRemark({commit}, payload) {
    console.log('This is the following ', payload);
    commit('set_crew_ton_remark', payload);
  },

  /** from tons  **/
  setCrewTonRemarks({commit}, payload) {
    commit('set_crew_ton_remarks', payload);
  },

  /** createTonRemark **/
  createTonRemark({commit}, payload) {
    console.log('This is the payload', payload);

    let authPos = AppService.originalState('auth', 'authPos');
    let url = null;

    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_CREW_TON_REMARKS;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_CREW_TON_REMARKS;
        break;
    }

    return axios.post(url, payload).then((r) => {
      commit('create_ton_remark', r.data);
      return true;
    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Create Remarks');
      return false;

    });
  },

  /** updateTonRemark **/
  updateTonRemark({commit}, payload) {
    let authPos = AppService.originalState('auth', 'authPos');
    let url = null;

    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_CREW_TON_REMARKS;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_CREW_TON_REMARKS;
        break;
    }

    return axios.put(`${url}/${payload.remarkId}`, payload).
        then((r) => {
          commit('update_ton_remark', r.data);
          return true;
        }).
        catch((er) => {
          AlertService.responseAlertMessage(er, 'Update remarks');
          return false;
        });
  },

  deleteTonRemark({commit}, payload) {

    let authPos = AppService.originalState('auth', 'authPos');
    let url = null;

    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_CREW_TON_REMARKS;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_CREW_TON_REMARKS;
        break;
    }

    return axios.delete(`${url}/${payload.remarkId}`).then((r) => {
      commit('delete_ton_remark', r.data);
      return true;

    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Delete remarks');
      return false;

    });
  },

  resetCrewTonRemarksState({commit}) {
    commit('reset_crew_ton_remarks_state');
  },

  resetCrewTonRemark({commit}) {
    commit('reset_crew_ton_remark');
  },

  getCrewTonRemarkOriginal({commit}) {
    let crewTonRemarkPresist = AppService.originalState('crewtonremark', 'crewTonRemark');
    commit('update_ton_remark', crewTonRemarkPresist);
  },
};

/** getters **/
const getters = {
  crewTonRemark: state => state.crewTonRemark,
  crewTonRemarks: state => state.crewTonRemarks,
  newCrewTonRemark: state => state.newCrewTonRemark,
};

/** export **/
export default {state, actions, mutations, getters};
